export default __webpack_public_path__ + "8126dcf616f9d71c4504dbf4d89a48bd.svg";